

<div class="row w-100 justify-between items-center">
  <button mat-raised-button color="primary" class="page-button" *ngIf="state === 'list'" (click)="createEvent()">Crear evento</button>
  <button mat-raised-button color="primary" class="page-button" *ngIf="state === 'list'" (click)="createGift()">Crear Regalo</button>
  <!-- <button mat-raised-button color="primary" class="page-button" (click)="geminiService.TestGeminiPro()">
    Test gemini
  </button> -->
  <div >
    Notificaciones restantes este mes: {{this.dataService.monthNotifications}}
  </div>
</div>
 <!-- Breadcrumbs for navigation -->

<div *ngIf="loading">
  <div class="loading">
    <mat-spinner color="accent" diameter="40"></mat-spinner>
  </div>
</div>

  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="state === 'list'; else showBackToList">
        Event List
      </li>
      <ng-template #showBackToList>
        <li class="breadcrumb-item" (click)="cancelEdit()">Event List</li>
        <li class="breadcrumb-item active" aria-current="page">{{state === 'view' ? 'Event Details': state === 'create' ? 'Create event': 'Edit event'}}</li>
      </ng-template>
    </ol>
  </nav>
  
  <div *ngIf="state !== 'create' && state !== 'edit' && state !== 'gift' ">
    <div *ngIf="data?.length > 0 else noData"class="events-container">
      <!-- DESKTOP DISPLAY  -->
      <div class="mat-table-container" *ngIf="!isMobile" >
        <table matSort (matSortChange)="sortData($event)" class="mat-elevation-z2" [ngClass]="state === 'view' ? 'edit-table': ''">
          <tr>
            <!-- Update your table header with the modified content -->
            <th mat-sort-header="fullName">
              <div class="cell-header">Titulo</div>
            </th>
            <th mat-sort-header="categories">
              <div class="cell-header">Categorías</div>
            </th>
            <th mat-sort-header="startDateOfEvent">
              <div class="cell-header">Comienzo</div>
            </th>
            <th mat-sort-header="dueDateOfEvent">
              <div class="cell-header">Culminación</div>
            </th>
            <th mat-sort-header="createdAt">
              <div class="cell-header">Creado</div>
            </th>
            <th mat-sort-header="availableReservation">
              <div class="cell-header">Reservas</div>
            </th>
            <th mat-sort-header="locationName">
              <div class="cell-header">Ubicación</div>
            </th>
            <th mat-sort-header="likeCount">
              <div class="cell-header">Me gusta</div>
            </th>
            <th mat-sort-header="priceRange">
              <div class="cell-header">Precio</div>
            </th>
            <th mat-sort-header="clicks">
              <div class="cell-header">Clicks</div>
            </th>
            <th mat-sort-header="feedback">
              <div class="cell-header">Calificación</div>
            </th>
            <th mat-sort-header="isOffer">
              <div class="cell-header">Promoción</div>
            </th>
            <th mat-sort-header="wantToReserve">
              <div class="cell-header">Contactado</div>
            </th>
            <th mat-sort-header="shared">
              <div class="cell-header">Compartido</div>
            </th>
            <th mat-sort-header="saved">
              <div class="cell-header">Guardado</div>
            </th>
            
          </tr>
            <tr *ngFor="let element of sortedData" class="cell-content" (click)="selectEvent(element)">
              <td>{{element.fullName}}</td>
              <td>
                <mat-chip-list>
                  <mat-chip *ngFor="let category of element.categories">
                  {{ getCategoryName(category) }}
                  </mat-chip>
                </mat-chip-list>
              </td>

              <td>
                {{ element.startDateOfEvent.seconds * 1000 |  date:'shortDate':'es'}}
              </td>

              <td>
                {{ element.dueDateOfEvent.seconds * 1000 | date:'shortDate':'es'}}
              </td>

              <td>
                {{ element.createdAt.seconds * 1000 |  date:'shortDate':'es'}}
              </td>

              <td>
                {{ element.availableReservation | boolean }}
              </td>

              <td>
                {{ element.locationName }}
              </td>

              <td>
                {{ element.likeCount }}
              </td>

              <td>
                {{ element.priceRange | formattedPrice}} 
              </td>

              <td>
                {{ element.clicks }}
              </td>

              <td>
                {{ element.feedback }}
              </td>

              <td>
                {{ element?.isOffer | boolean}}
              </td>

              <td>
                {{ element.wantToReserve }}
              </td>

              <td>
                {{ element.shared }}
              </td>

              <td>
                {{ element.saved }} 
              </td>
            </tr>
      
        </table>
      </div>
      <!-- VISUALIZE DISPLAY OF EVENT -->
      <mat-card class="card edit-card" *ngIf="state === 'view'">
        <mat-card-content>
          <div class="icons">
            <mat-icon class="edit-icon" (click)="edit(selectedEvent)">
              edit
            </mat-icon>
            <mat-icon class="close" (click)="cancelEdit()">
              close
            </mat-icon>
          </div>
          <img [src]="imageUrl" alt="event image">

          <div *ngIf="notificationSent" 
          class="row w-100 mv1 items-center justify-between">
            <h2 class="m0">{{ selectedEvent.fullName }}</h2>
            <div class="chip">
              Notificación enviada 
            </div>
          </div>


          <mat-slide-toggle class="mv1"   [ngClass]="sendNotification? ' mb0':'' "(change)="sendNotification = !sendNotification;" 
          [checked]="sendNotification">Mandar notificacion</mat-slide-toggle>
          
          <form class="mv1" [formGroup]="newNotificationForm" *ngIf="sendNotification">
            <mat-form-field appearance="outline" color="accent">
              <mat-label>
                Titulo de la notificacion
              </mat-label>
              <input matInput type="text" formControlName="title">
            </mat-form-field>
            <button [disabled]="!newNotificationForm.valid" mat-raised-button color="primary" (click)="sendNotificationForSelecetedEvent()">
              Mandar notificacion de este evento! 
            </button>
          </form>

          <p>Descripción: {{ selectedEvent.description }}</p>
          <div>
            <p>
              Categorías: 
            </p>
            <mat-chip-list>
              <mat-chip *ngFor="let category of selectedEvent.categories">
                {{ getCategoryName(category) }}
              </mat-chip>
            </mat-chip-list>
          </div>
          <p>Id: {{ selectedEvent.eventId }}</p>
          <p>Inicio: {{ selectedEvent.startDateOfEvent.seconds * 1000 |  date:'shortDate':'es' }}</p>
          <p>Culminación: {{ selectedEvent.dueDateOfEvent.seconds * 1000 | date:'shortDate':'es' }}</p>
          <p>Fecha de creación : {{ selectedEvent.createdAt.seconds * 1000 |  date:'shortDate':'es' }}</p>
          <p>Reservas habilitadas: {{ selectedEvent.availableReservation | boolean }}</p>
          <p>Promoción: {{ selectedEvent?.isOffer | boolean }}</p>
          <p>Link de google maps : {{ selectedEvent.locationName }}</p>
          <p>Conteo de "me gusta": {{ selectedEvent.likes }}</p>
          <p>Precio: {{ selectedEvent.priceRange | formattedPrice}}</p>
          <!-- <p>Reservation Count: {{ selectedEvent.reservationsCount }}</p> -->
          <p>Clicks: {{ selectedEvent.clicks }}</p>
          <p>Guardados: {{ selectedEvent.saved }}</p>
          <p>Retroalimentación: {{ selectedEvent.feedback }}</p>
          <p>Compartido: {{ selectedEvent.shared }}</p>
          <p>Wahtsapp alcance: {{ selectedEvent.wantToReserve }}</p>
        </mat-card-content>
      </mat-card>
  
      <!-- MOBILE DISPLAY -->
      <div class="flex" *ngIf="isMobile">
        <div class="card-container" >
            <mat-card class="card" *ngFor="let item of data">
              <mat-card-content>
                <h2>{{ item.fullName }}</h2>
                <p>Descripción: {{ item.description }}</p>
                <div>
                  <p>
                    Categorías: 
                  </p>
                  <mat-chip-list>
                    <mat-chip *ngFor="let category of item.categories">
                      {{ getCategoryName(category) }}
                    </mat-chip>
                  </mat-chip-list>
                </div>
                <p>Inicio: {{ item.startDateOfEvent.seconds * 1000 |  date:'shortDate':'es' }}</p>
                <p>Culminación: {{ item.dueDateOfEvent.seconds * 1000 | date:'shortDate':'es' }}</p>
                <p>Fecha de creación: {{ item.createdAt.seconds * 1000 | date:'shortDate':'es'}}</p>
                <p>Reservas habilitadas: {{ item.availableReservation | boolean}}</p>
                <p>Promoción: {{ item?.isOffer | boolean}}</p>
                <p>Link de google maps : {{ item.locationName }}</p>
                <p>Conteo de "me gusta": {{ item.likeCount }}</p>
                <p>Precio: {{ item.priceRange | formattedPrice}}</p>
                <!-- <p>Reservation Count: {{ item.reservationsCount }}</p> -->
                <p>Clicks: {{ item.clicks }}</p>
              </mat-card-content>
            </mat-card>
          </div>
      </div>
    </div>
  
    <ng-template #noData>
      <div>
        <p>
          No tienes eventos todavía 
        </p>
        <br>
        <h3>
          ¡Crea un evento y comienza la safaera!
        </h3>
      </div>
    </ng-template>
  
  
  </div>
  
  <app-event-form *ngIf="state === 'create' || state === 'edit'"
  [selectedEvent]="selectedEvent"
  [state]="state"
  [imageUrl]="imageUrl"
  (saved)="eventSaved($event)"
  >

  </app-event-form>

  <app-gift-form *ngIf="state === 'gift'" [state]="'create'">
  </app-gift-form>


